import { Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { useTranslation } from 'react-i18next';
import { printDocument } from './printDocument';

export default function PrintButton({ onClick }) {
  const { t } = useTranslation();
  return (
    <Button
      variant="contained"
      size="small"
      startIcon={<PrintIcon />}
      onClick={onClick ?? printDocument}
      sx={{ background: '#032C65', '&:hover': { background: '#021a40' } }}
    >
      {t('print')}
    </Button>
  );
}
